import popupBar from './popup'
import operation from './operationBar'
import search from './searchBar'
import searchChocie from './searchBarChocie'
import pagination from './Pagination'
const operationBar = {
  install (Vue) {
    Vue.component('operationBar', operation)
  }
}

const searchBar = {
  install (Vue) {
    Vue.component('searchBar', search)
  }
}

const searchBarChocie = {
  install (Vue) {
    Vue.component('searchBarChocie', searchChocie)
  }
}

const popup = {
  install (Vue) {
    Vue.component('popup', popupBar)
  }
}

const GPagination = {
  install (Vue) {
    Vue.component('GPagination', pagination)
  }
}

export {
  popup,
  operationBar,
  searchBar,
  searchBarChocie,
  GPagination
}



// WEBPACK FOOTER //
// ./src/components/operrationOrsearch.js